import {
  CART_MOMENT_URL_V2,
  CART_MOMENTS_URL_V2,
  CART_ITEMS_URL,
  PURCHASE_REQUEST_URL,
  PURCHASES_URL,
  PRINTS_URL,
  PURCHASED_MOMENT_IDS_URL,
  PURCHASE_CALCULATIONS_URL,
  APPLY_DISCOUNT_CODE_URL,
  PRINT_SIZE_SELECTION_URL,
  CLEAR_PRINT_SIZE_SELECTION,
  RE_KNOCKOUT_MOMENT_URL
} from 'shared/utils/Constants';

import { get, post, patch, destroy, put } from 'shared/services/ApiService';

class CartService {
  getMoments(token, storyId, page = 1, perPage = 100, moments = []) {
    return get(CART_MOMENTS_URL_V2(storyId, page, perPage))
      .then(momentsPage => {
        momentsPage = momentsPage ?? [];
        moments = moments.concat(momentsPage);

        if (momentsPage.length === perPage) {
          return this.getMoments(token, storyId, page + 1, perPage, moments);
        }

        return Promise.resolve(moments);
      });
  }

  async getSelections(storyId) {
    return await get(CART_ITEMS_URL(storyId));
  }

  selectMoments(storyId, momentIds) {
    const params = {
      moment_ids: momentIds
    }

    return post(CART_ITEMS_URL(storyId), params);
  }

  async unselectMoments(storyId, momentIds) {
    const params = {
      moment_ids: momentIds
    }

    return await patch(CART_ITEMS_URL(storyId), params);
  }

  clearSelections(storyId) {
    return destroy(CART_ITEMS_URL(storyId));
  }

  removeMoment(storyId, momentId) {
    return destroy(CART_MOMENT_URL_V2(storyId, momentId));
  }

  createPurchaseRequest(token, params) {
    return post(PURCHASE_REQUEST_URL(token), params);
  }

  getPurchases(storyId) {
    return get(PURCHASES_URL(storyId));
  }

  getPrints(token) {
    return get(PRINTS_URL(token));
  }

  async selectPrints(storyId, momentIds, v2) {
    const params = { moment_ids: momentIds, v2 };
    return await post(PRINTS_URL(storyId), params);
  }

  async unselectPrints(storyId, moment_ids, v2 = false, clear_all = false) {
    const params = { moment_ids, v2, clear_all };
    return await patch(PRINTS_URL(storyId), params);
  }

  getPurchasedMomentIds(storyId) {
    return get(PURCHASED_MOMENT_IDS_URL(storyId));
  }

  getPurchaseCalculations(storyId, maxQuantity, couponCode = "") {
    const params = {
      story_id: storyId,
      max_quantity: maxQuantity,
      coupon_code: couponCode,
    };

    return post(PURCHASE_CALCULATIONS_URL, params);
  }

  async applyDiscountCode(productId, couponCode, purchaseTotal) {
    const params = {
      unique_code: couponCode,
      product_id: productId,
      purchase_total: purchaseTotal
    }
    return post(APPLY_DISCOUNT_CODE_URL, params).catch((response) => {
      console.log(response);
    });
  }

  async getSelectedPrintSizes(storyId) {
    return await get(PRINT_SIZE_SELECTION_URL(storyId));
  }

  async selectPrintSizes(storyId, params) {
    return post(PRINT_SIZE_SELECTION_URL(storyId), params);
  }

  async clearSelectedPrintSizes(storyId, momentId) {
    return destroy(CLEAR_PRINT_SIZE_SELECTION(storyId, momentId));
  }

  async reKnockOutMoment(momentId, kioskToken) {
    return put(RE_KNOCKOUT_MOMENT_URL(momentId, kioskToken));
  }
}

export default new CartService();
